import React from 'react';

import { t } from 'ttag';

import Alert from '../../../ui/Alert/Alert';
import Card from '../../../ui/card/card';
import PseudoLink from '../../../ui/pseudolink/pseudolink';

import { reloadPage } from '../../../../lib/navigation';
import FlexBox from '../../../FlexBox/FlexBox';

import css from './ErrorCard.css';

interface ErrorCardProps {
    errorMessage: string;
}

const ErrorCard: React.FC<ErrorCardProps> = ({ errorMessage }) => {
    const handleReload = () => reloadPage();

    return (
        <FlexBox className={css.root} justify="center" align="center">
            <Card>
                <FlexBox direction="column">
                    <Alert hideIcon theme="error">
                        Error: {errorMessage}
                        <br />
                        {t`Будь ласка, зверніться до технічної підтримки.`}
                    </Alert>
                    <div>
                        <PseudoLink
                            onClick={handleReload}
                        >{t`Перезавантажити`}</PseudoLink>
                    </div>
                </FlexBox>
            </Card>
        </FlexBox>
    );
};

export default ErrorCard;
